(function(){
    'use strict';

    angular
    .module('app')
    .controller('DecimalesconfigController', DecimalesconfigController)
 
    DecimalesconfigController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function DecimalesconfigController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.json = "";
        vm.decimales = "";
        vm.update = function(){
            var j = JSON.parse($('#fieldconfig-value').val());

        	console.log(vm.limit);
			
            j.references["decimales"] = vm.decimales;

			vm.scopeParent.$parent.fieldsVm.jsonValue = angular.toJson(j);
			$('#fieldconfig-value').val(vm.scopeParent.$parent.fieldsVm.jsonValue);
        }
        vm.init = function(scopeParent){
        	vm.scopeParent = scopeParent;
        	//console.log(scopeParent);
        	var valorJson = $('#fieldconfig-value').val();
        	if(valorJson!=""){
        		vm.json = JSON.parse(valorJson);
        		if(typeof vm.json.references.decimales!='undefined'){
                    vm.decimales = vm.json.references.decimales;
                }
        	}
        	console.log("entro",vm.json);
        	vm.update();
        }
    } 

})();